if($('.type-category').length){
    if($('.category-top .subcategories').length){
        $('.category-top').after($('.category-top .subcategories'))
    }
        function customCategory(){
            if($('.category-top .category-perex p[style="text-align: justify;"]').length){
                $('.category-top').addClass('haveDescription')
            }

            if(!$('.category-header .filters-unveil-button-wrapper').length){
                $('.filters-unveil-button-wrapper').clone().appendTo('.category-header')
            }
            if(!$('#filters-wrapper #filters .close').length){
                $('#filters-wrapper #filters').prepend('<span class="close"></span>')
            }
        }
        $(document).ready(function(){
            customCategory()
        })
        document.addEventListener('ShoptetDOMContentLoaded', function () {
            customCategory()
        });
}

$(document).on('click', '#filters span.close', function(){
    $('.filters-unveil-button-wrapper a').trigger('click')
    $('#filters').removeClass('visible')
    $('body').removeClass('.filters-visible')
})

